import React from 'react'
import { isEmpty, filter, size } from 'lodash';
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import { Box, Typography, Button, Grid, TextareaAutosize, Table, TableContainer, TableHead, TableRow, Paper, TableBody, Snackbar, Alert } from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import { styled } from '@mui/material/styles';
import axios from 'axios'
import fileDownload from 'js-file-download'
import legolasApi from '../../api/legolas';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    minWidth: '50px'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function CreditMemoDetails() {

  const { state } = useLocation();
  const { data, source } = state || {};
  console.log("source ", source)
  const navigate = useNavigate()
  const { id: orderId } = useParams();
  const [orderData, setOrderData] = React.useState({});
  const [creditMemoData, setCreditMemoData] = React.useState({});
  const [creditMemopdf,setCreditMemopdf] = React.useState({});
  const [openAlert, setOpenAlert] = React.useState(false);
  const [alertText, setAlertText] = React.useState('');
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];

  React.useEffect(() => {
    if (!orderId) return;

    axios.get(`${legolasApi.url}/orders/${orderId}`).then((res) => {
      const response = res.data.data;

    const channelId = response?.summary?.channel_id;
    if (!userChannels.includes(String(channelId))) {
      setAlertText('You are not authorized to view this credit memo.');
      setOpenAlert(true);
      return; 
    }
    setOrderData(response);

    axios.get(`${legolasApi.url}/admin/getcreditMemo/${data.orderId}`).then((rest) => {
      setCreditMemoData(rest.data.data);
    }).catch((err) => {
      console.error('Failed to load credit memo:', err);
    });
  }).catch((err) => {
    console.error('Failed to load order:', err);
    setAlertText('Failed to load credit memo data.');
    setOpenAlert(true);
  });
}, [orderId]);


  const getFinalDiscount = () =>{
    let totalCouponDiscount = 0.00;
    if (!isEmpty(creditMemoData)){
      creditMemoData.items.forEach((item) => {
        if(parseInt(item.qtyRefund) > 0 && parseFloat(orderData.summary.discount_amount) > 0){
          const itemDiscountAmt = filter(orderData.items, (orderItem) => {
            return orderItem.id === item.id;
          });

          const qtyRefund = parseFloat(item.qtyRefund);
          const discount = size(itemDiscountAmt) > 0 ? parseFloat(itemDiscountAmt[0].discount) : 0.00;
          const itemPrice = parseFloat(item.price_incl_tax);
          if(parseFloat(orderData.summary.discount_amount) > 0 && parseInt(orderData.summary.order_id) > parseInt(process.env.REACT_APP_LAST_ORDER_ID)){
            totalCouponDiscount = totalCouponDiscount + (discount * qtyRefund);
          }else if(parseFloat(orderData.summary.discount_amount) > 0 && discount > 0) {
            totalCouponDiscount = totalCouponDiscount + (discount * qtyRefund);
          }else if(parseFloat(orderData.summary.discount_amount) > 0 && discount == 0){
            totalCouponDiscount = totalCouponDiscount + parseFloat(((parseFloat(itemPrice) * qtyRefund * parseFloat(process.env.REACT_APP_DISCOUNT_PERCENT)) /100));
          }
        } 
      });
    }
    return (parseFloat(totalCouponDiscount)).toFixed(2);
  }

  const getCreditItems = () => {
    const creditItems=[];
      creditMemoData.items.map((item) => {
      if(parseInt(item.qtyRefund) > 0) {
        item.quantity = parseInt(item.qtyRefund);
        item.rowTotal = parseInt(item.qtyRefund) * parseFloat(item.price_incl_tax);
        creditItems.push(item);
      }
    });
    return creditItems;
  }

console.log("creditMemoData sensii",creditMemoData)
  //integrate pdf generation here
  const createPdf = () => {
    const pdfPayload = {
      invoiceNumber: data.invoiceNumber,
      vatNumber: '300101252300003',
      orderNumber: orderData.summary.order_id,
      CreditnoteNumber: creditMemoData.increment_id,
      orderDate: orderData.summary.placedOn,
      billingAddress: shipment,
      shippingAddress: shipment,
      paymentMethod: transaction,
      shippingMethod: orderData.summary.shipping_name,
      items:getCreditItems(),
      subtotal: creditMemoData.subtotal,
      discount: getFinalDiscount(),
      codfee: creditMemoData.cod_fee_incl_tax,
      totalTax: creditMemoData.totalVat,
      shipping: creditMemoData.shipping_amount,
      Price: creditMemoData.total_price,
      TotalSavings: (parseFloat(creditMemoData.total_discount) || 0) + (parseFloat(getFinalDiscount()) || 0),
      grandTotal: creditMemoData.grand_total,
      payment_id: parseInt(orderData.summary.fk_payment_id),
      tamaraFee: (creditMemoData.tamara_fee_incl_tax) ? creditMemoData.tamara_fee_incl_tax : orderData.summary.tamara_fee_incl_tax,
      tabbyFee: (creditMemoData.tabby_fee_incl_tax) ? creditMemoData.tabby_fee_incl_tax : orderData.summary.tabby_fee_incl_tax,
      channel: orderData.summary.channel_id
    };
     if (Number(orderData.summary.one_day_delivery_charge) > 0) {
      pdfPayload.one_day_delivery_charge = parseFloat(orderData.summary.one_day_delivery_charge);
    }
    axios({

      url: `${legolasApi.url}/admin/generatepdf`,
      method: 'POST',
      data: pdfPayload,
      responseType: 'blob'
    }).then((res) => {
      const invoiceNumber = orderData.summary.order_id
      fileDownload(res.data, `creditmemo_${invoiceNumber}.pdf`)
    });
  }

  const sendEmail = () => {
    const emailPayload = {
      customerName: orderData.customer.firstname,
      orderNumber: data.orderId,
      customerEmail: orderData.customer.email ? orderData.customer.email :orderData.customer.guest_user_email,
      channel: orderData.summary.channel_id
    };
    axios.post(`${legolasApi.url}/admin/sendmail`, emailPayload).then((res) => {
      console.log('email res')
      console.log(res)
    });
  }
  
  const printAndSendInvoice = () => {
    console.log("data.shippingAddress",data);
    const pdfPayload = {
      invoiceNumber: data.invoiceNumber,
      vatNumber: '300101252300003',
      orderNumber: orderData.summary.order_id,
      CreditnoteNumber: creditMemoData.increment_id,
      orderDate: orderData.summary.placedOn,
      billingAddress: shipment,
      shippingAddress: shipment,
      paymentMethod: transaction,
      shippingMethod: orderData.summary.shipping_name,
      items: getCreditItems(),
      subtotal: creditMemoData.subtotal,
      discount: getFinalDiscount(),
      codfee: creditMemoData.cod_fee_incl_tax,
      totalTax: creditMemoData.totalVat,
      shipping: creditMemoData.shipping_amount,
      Price: creditMemoData.total_price,
      TotalSavings: (parseFloat(creditMemoData.total_discount) || 0) + (parseFloat(getFinalDiscount()) || 0),
      grandTotal: creditMemoData.grand_total,
      payment_id: parseInt(orderData.summary.fk_payment_id),
      tamaraFee: (creditMemoData.tamara_fee_incl_tax) ? creditMemoData.tamara_fee_incl_tax : orderData.summary.tamara_fee_incl_tax,
      tabbyFee: (creditMemoData.tabby_fee_incl_tax) ? creditMemoData.tabby_fee_incl_tax : orderData.summary.tabby_fee_incl_tax,
      channel: orderData.summary.channel_id
    };
     if (Number(orderData.summary.one_day_delivery_charge) > 0) {
      pdfPayload.one_day_delivery_charge = parseFloat(orderData.summary.one_day_delivery_charge);
    }
    const emailPayload = {
      customerName: data.billingAddress['customer_firstname'],
      orderNumber: data.orderId,
      customerEmail: orderData.customer.guest_user_email ? orderData.customer.guest_user_email : orderData.customer.email,
      channel:orderData.summary.channel_id
    };
    axios({
      url: `${legolasApi.url}/admin/generatepdf`,
      method: 'POST',
      data: pdfPayload,
      responseType: 'blob'
    }).then((res) => {
      const invoiceNumber = orderData.summary.order_id
      fileDownload(res.data, `${invoiceNumber}.pdf`)
      axios.post(`${legolasApi.url}/admin/sendmail`, emailPayload).then((res) => {
        console.log('email res')
        console.log(res)
      });
    });
  }

  const handleBackClick = () => {
    navigate(-1);
  }
  

  const darkBox = {
    width: '96%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#dcdbdb',
    padding: '10px'
  }
  const lightBox = {
    width: '96%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    padding: '10px'
  }

  const subHeader = {
    fontSize: '1.2rem',
    fontWeight: 700,
    paddingBottom: '20px'
  }

  const purchasedFromDefault = 'Shababuna Website';

  if (isEmpty(orderData)) {
    return;
  }
  if(isEmpty(creditMemoData)){
    return;
  }
  const { summary, shipment, transaction, customer} = orderData;
  // const computedGrandTotal = (parseFloat(summary.grand_total) || 0) + (parseFloat(summary.one_day_delivery_charge) || 0);

  const AddressInfo = () => {
    return (
      <React.Fragment>
        <Box sx={{ display: 'inline' }}>
          <Typography sx={{ paddingRight: '5px', wordBreak:"break-word" }}>{shipment.customer_firstname ? shipment.customer_firstname : null}</Typography>
          <Typography sx={{wordBreak:"break-word"}}>{shipment.customer_lastname ? shipment.customer_lastname : null}</Typography>
        </Box>
        <Typography sx={{wordBreak:"break-word"}}>{shipment.street ? shipment.street : null}</Typography>
        <Typography>{shipment.district ? shipment.district : null}</Typography>
        <Box sx={{ display: 'inline-flex' }}>
          <Typography>{shipment.city ? shipment.city : null}</Typography>,
          <Typography sx={{ paddingLeft: '5px' }}>{shipment.postcode ? shipment.postcode : 560034}</Typography>
        </Box>
        <Typography>{shipment.country ? shipment.country : null}</Typography>
        <Box sx={{ display: 'inline-flex' }}>
          <Typography sx={{ paddingRight: '5px' }}>T:</Typography>
          <Typography>{shipment.phone ? shipment.phone : null}</Typography>
        </Box>
      </React.Fragment>
    )
  }

const ItemsList = () => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell align="center">ID</StyledTableCell>
            <StyledTableCell align="center">Product</StyledTableCell>
            <StyledTableCell align="center">Price</StyledTableCell>
            <StyledTableCell align="center">Quantity</StyledTableCell>
            {/* <StyledTableCell align="center">Mage ID</StyledTableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {creditMemoData.items.map((item) => {
            // console.log("Order Items",item);
            if(parseInt(item.qtyRefund) > 0) {
              return (
                <StyledTableRow key={item.id}>
                <StyledTableCell sx={{'& .MuiTypography-root': { fontSize: '14px' } }}>
                  <Typography variant='h6'>ID: {item.id}</Typography>
                  <Typography variant='h6'>SKU: {item.sku}</Typography>
                </StyledTableCell>
                <StyledTableCell sx={{}}>{item.name}
                  <span><b>{!item.is_gift_product || item.is_gift_product === 0 || item.is_gift_product === null ? "" : " ( Gift Item )"}</b></span>
                </StyledTableCell>
                <StyledTableCell>SAR {item.price_incl_tax}</StyledTableCell>
                <StyledTableCell sx={{ display: 'flex', flexDirection: 'column', '& .MuiTypography-root': { fontSize: '14px' } }}>
                  <Typography variant='h6'>{item.qtyRefund}</Typography>
                </StyledTableCell>
              </StyledTableRow>
              )
            } 
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

  return (
    <Box sx={{ width: '97%', height: 'auto', backgroundColor: '#fff !important', margin: '0px 20px' }}>
      <Snackbar
        open={openAlert}
        autoHideDuration={10000} // for debug
        onClose={() => setOpenAlert(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenAlert(false)} severity="error" sx={{ width: '400px', marginTop: '100px' }}>
          {alertText}
        </Alert>
      </Snackbar>
      <Box sx={{
        display: 'flex', justifyContent: 'space-between', margin: '30px 20px',
        '& .MuiTypography-root': {
          fontSize: '2.5rem',
          fontWeight: 400,
          color: '#000'
        }
      }}>
        <Typography>#{creditMemoData.increment_id}</Typography>
      </Box>
      <Box sx={{
        display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey,
        margin: '15px 0px',
        '& .MuiButton-root': {
          padding: '10px 30px',
          backgroundColor: globalStyles.colors.backgroundPrimary,
          color: globalStyles.colors.white,
          borderRadius: '0px',
          margin: '10px',
          textTransform: 'capitalize'
        }
      }}
      >
        <Button onClick={() => handleBackClick()}>Back</Button>
        <Button onClick={() => printAndSendInvoice()}>Print & Send Credit Memo</Button>
        <Button onClick={() => sendEmail()}>Send Email</Button>
        <Button onClick={() => createPdf()}>Print</Button>
      </Box>
      <Box id='order-container'>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>Order & Account Information</Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={subHeader}>
              Order # {orderData.summary.order_id} (The order confirmation email was sent)
            </Typography>
            <Box sx={darkBox}>
              <Typography>Order Date</Typography>
              <Typography>{summary.placedOn}</Typography>
            </Box>

            <Box sx={lightBox}>
              <Typography>Order Status</Typography>
              {summary.order_status ?
                <Typography>{summary.order_status}</Typography> : <Typography sx={{ color: 'red' }}>Order status not set</Typography>}
            </Box>
            <Box sx={darkBox}>
              <Typography>Next Day Delivery </Typography>
              <Typography>{Number(summary.one_day_delivery_charge) > 0 ? "True" : "False"}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={subHeader}>
              Account Information
            </Typography>
            <Box sx={darkBox}>
              <Typography>Customer Name</Typography>
              <Typography sx={{wordBreak:"break-word", marginLeft:"10px"}}>{shipment.customer_firstname + ' ' + shipment.customer_lastname}</Typography>
            </Box>
            <Box sx={lightBox}>
              <Typography>Email</Typography>
              <Typography>{customer.email ? customer.email : null}</Typography>
            </Box>
            <Box sx={lightBox}>
              <Typography>Phone</Typography>
              {shipment.phone_ext && shipment.phone ?
                <Typography>{shipment.phone_ext + shipment.phone}</Typography> : <Typography sx={{ color: 'red' }}>Email not set</Typography>}
            </Box>
            <Box sx={darkBox}>
              <Typography>Customer Group</Typography>
              <Typography>GENERAL
              {/*{customer.user_group_code ? customer.user_group_code : null}*/}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box id='addressinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Address Information
          </Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Billing Address
            </Typography>
            <AddressInfo />
          </Grid>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Shipping Address
            </Typography>
            <AddressInfo />
          </Grid>
        </Grid>
      </Box>
      <Box id='paymentinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Payment & Shipping Method
          </Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Payment Information
            </Typography>
            <Box>
              {transaction.paymentType && (
                <Typography>{transaction.paymentType}</Typography>
              )}

              {/* Render last 4 digits if available */}
              {transaction.last4Digits && (
                <Typography>{transaction.last4Digits}</Typography>
              )}

              {/* Render payment brand only if it exists */}
              {transaction.paymentBrand && (
                <Typography>{transaction.paymentBrand}</Typography>
              )}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Shipping & Handling Information
            </Typography>
            <Box>
              <Typography>
                {[summary.shippingId] == 2 ? 'Aramex Shipping' : 'Shababuna Shipping'}
              </Typography>
            </Box>
            <Box>
              <Typography>Total Shipping Charges: <Typography sx={{ fontWeight: 700 }}>SAR {summary.shipping_incl_tax}</Typography></Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box id='itemsinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Items Refunded
          </Typography>
        </Box>
        <Box>
          <ItemsList />
        </Box>
      </Box>
      <Box id='total-container' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>Memo Total</Typography>
        </Box>
        <Grid container spacing={5} columns={24} sx={{ flexDirection: 'row-reverse' }}>
          {/* <Grid item xs={12}>
            <Typography variant='subtitle1' sx={subHeader}>
              Credit Memo History
            </Typography>
            <Box>
              <TextareaAutosize
                aria-label="minimum height"
                minRows={5}
                placeholder=" Comments"
                style={{ width: 500 }}
              />
            </Box>
          </Grid> */}
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={subHeader}>
              Credit Memo Totals
            </Typography>
            <Box sx={darkBox}>
              <Typography>Price</Typography>
              {/* <Typography> SAR{" "} {Array.isArray(order_items) && order_items.length > 0  ? Number(order_items[0].price_total || 0).toFixed(2)  : "0.00"} </Typography> */}
              <Typography>SAR {creditMemoData.total_price ? parseFloat(creditMemoData.total_price).toFixed(2) : (0.00).toFixed(2)}</Typography>
            </Box>
            {((parseFloat(creditMemoData.total_discount) || 0) + (parseFloat(getFinalDiscount()) || 0)) > 0 && (
              <>
                {/* Total Savings */}
                <Box sx={{ ...lightBox, display: 'flex', justifyContent: 'space-between' }}>
                  <Typography>Total Savings</Typography>
                  <Typography>
                    SAR {(
                      (parseFloat(creditMemoData.total_discount) || 0) + (parseFloat(getFinalDiscount()) || 0)
                    ).toFixed(2)}
                  </Typography>
                </Box>

                {/* Light Grey Breakdown Section */}
                <Box sx={{ backgroundColor: '#f5f5f5', borderRadius: '8px', padding: '10px', marginTop: '5px',marginRight:'32px' }}>
                  {/* Product Discount */}
                  {Number(creditMemoData.total_discount) > 0 && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', paddingLeft: '10px' }}>
                      <Typography>Product Discount</Typography>
                      <Typography>SAR {parseFloat(creditMemoData.total_discount).toFixed(2)}</Typography>
                    </Box>
                  )}

                  {/* Coupon Discount */}
                  {Number(getFinalDiscount()) > 0 && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', paddingLeft: '10px', marginTop: '5px' }}>
                      <Typography>Coupon Discount</Typography>
                      <Typography>SAR {parseFloat(getFinalDiscount()).toFixed(2)}</Typography>
                    </Box>
                  )}
                </Box>
              </>
            )}

            <Box sx={{ paddingBottom: '10px' }}>
              <Box sx={darkBox}>
                <Typography>Subtotal (incl. Tax)</Typography>
                  <Typography>
                     SAR {parseFloat(creditMemoData.subtotal).toFixed(2)}
                  </Typography>
              </Box>
              <Box sx={lightBox}>
                <Typography>Tax</Typography>
                  <Typography>
                    SAR {parseFloat(creditMemoData.totalVat).toFixed(2)}
                  </Typography> 
              </Box>
              {/* <Box sx={darkBox}>
                <Typography>Coupon Discount</Typography>
                <Typography>
                  SAR {getFinalDiscount()}
                </Typography>
              </Box> */}

              <Box sx={darkBox}>
                <Typography>Shipping & Handling</Typography>
                  <Typography>
                    SAR {parseFloat(creditMemoData.shipping_amount).toFixed(2)}
                  </Typography> 
              </Box>

              <Box sx={lightBox}>
                <Typography>Adjustment Refund	</Typography>
                  <Typography>
                    SAR {parseFloat(creditMemoData.adjustment_positive).toFixed(2)}
                  </Typography>
              </Box>
              <Box sx={darkBox}>
                <Typography>Adjustment Fee</Typography>
                  <Typography>
                    SAR {parseFloat(creditMemoData.adjustment_negative).toFixed(2)}
                  </Typography>
              </Box>
              <Box sx={lightBox}>
                <Typography>Cash on Delivery Fee (incl. Tax)</Typography>
                <Typography>
                  SAR {parseFloat(creditMemoData.cod_fee_incl_tax).toFixed(2)}
                </Typography>
              </Box>
              {
                parseInt(summary.fk_payment_id) === 5 && 
                <Box sx={darkBox}>
                  <Typography>Tamara Processing Fee</Typography>
                  <Typography>
                    SAR {((creditMemoData.cod_fee_incl_tax) ? parseFloat(creditMemoData.cod_fee_incl_tax).toFixed(2) : parseFloat(summary.tamara_fee_incl_tax).toFixed(2))}
                  </Typography>
                </Box>
              }
              {
                parseInt(summary.fk_payment_id) === 6 &&
                <Box sx={lightBox}>
                  <Typography>Tabby Processing Fee</Typography>
                  <Typography>
                  SAR {
        !isNaN(parseFloat(creditMemoData.cod_fee_incl_tax)) 
          ? parseFloat(creditMemoData.cod_fee_incl_tax).toFixed(2) 
          : !isNaN(parseFloat(summary.tabby_fee_incl_tax)) 
          ? parseFloat(summary.tabby_fee_incl_tax).toFixed(2) 
          : '0.00'
      }                  </Typography>
                </Box>
              }
              {Number(summary.one_day_delivery_charge) > 0 && (
                <Box sx={darkBox}>
                  <Typography>Next Day Delivery Fee</Typography>
                  <Typography>SAR {parseFloat(summary.one_day_delivery_charge).toFixed(2)}</Typography>
                </Box>
              )}
              <Box sx={lightBox}>
                <Typography sx={{ fontSize: '1rem', fontWeight: 700 }}>Grand Total</Typography>
                <Typography> SAR {parseFloat(creditMemoData.grand_total).toFixed(2)}</Typography>
                {/* <Typography>SAR {computedGrandTotal.toFixed(2)}</Typography> */}
                  
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default CreditMemoDetails;